import Frame from "images/sh_frame.svg";
import React, { ReactNode } from "react";
export const PageIntro = ({
    overviewNode,
    introContent,
    introTitle
}: {
    overviewNode: ReactNode;
    introContent?: ReactNode;
    introTitle?: string;
}) => {
    return (
        <div className="flex flex-col items-start gap-y-8 md:flex-row-reverse">
            {introContent && (
                <div className=" bg-[#F4F4F4] p-6 sm:p-10 md:flex-1">
                    <div className="mb-8">
                        <img
                            src={Frame}
                            className="relative top-[-6px] mr-[30px] inline h-[32px] w-[32px]"
                        />
                        <span className="text-2xl leading-8 text-sh-red">
                            Overview{introTitle ? ": " : ""}
                        </span>
                        <span className="text-2xl leading-8">{introTitle}</span>
                    </div>
                    {introContent}
                </div>
            )}
            <div
                className={`w-full p-6 sm:p-10 md:flex-1 ${
                    !introContent && "text-center"
                }`}
            >
                <div className="mb-8 text-xl">Explore more about:</div>
                {overviewNode}
            </div>
        </div>
    );
};
